import { FormattedMessage } from 'react-intl';

import { Dropdown } from '@/modules/ui';
import { AccessRole } from '@/types';

import { PasskeyOnlyRole } from './PasskeyOnlyRole';
import * as felaRules from './RoleDropdown.rules';

export interface RoleDropdownProps {
    value: AccessRole;
    onChange: (value: AccessRole) => void;
    hasPasskey?: boolean;
    /** Narrows the offered roles. Vaults pass two; record sharing offers all four. */
    roles?: AccessRole[];
}

const permissions = [AccessRole.VIEWER, AccessRole.EDITOR, AccessRole.VIEWER_AUTOFILL_ONLY, AccessRole.VIEWER_PASSKEY_ONLY];

export const RoleDropdown = ({ value, onChange, hasPasskey = false, roles = permissions }: RoleDropdownProps) => (
    <Dropdown
        items={roles.map(permission => ({
            key: permission,
            label:
                permission === AccessRole.VIEWER_PASSKEY_ONLY ? (
                    <PasskeyOnlyRole disabled={!hasPasskey} />
                ) : (
                    <FormattedMessage id={`secret.permission.${permission}`} />
                ),
            active: value === permission,
            disabled: permission === AccessRole.VIEWER_PASSKEY_ONLY && !hasPasskey,
            onClick: () => {
                onChange(permission);
            },
        }))}
        customStyle={felaRules.dropdown}
    >
        <FormattedMessage id={`secret.permission.${value}`} />
    </Dropdown>
);
